import React from "react";

const WORDS = ["ARKITEKTUR", "LYSINDFALD", "MATERIALER", "KOMFORT", "ÆSTETIK", "HÅNDVÆRK"];

export default function Marquee() {
  const items = [...WORDS, ...WORDS];
  return (
    <div className="w-full overflow-hidden border-y border-border/70 py-6 md:py-8 bg-background select-none">
      <div className="hg-marquee-track">
        {items.map((w, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-display text-3xl md:text-5xl font-light text-foreground/80 px-6 md:px-10">
              {w}
            </span>
            <span className="text-accent text-2xl md:text-3xl">&#9670;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
